import { render, staticRenderFns } from "./preInscricao.vue?vue&type=template&id=bc715584&scoped=true"
import script from "./preInscricao.vue?vue&type=script&lang=js"
export * from "./preInscricao.vue?vue&type=script&lang=js"
import style0 from "./preInscricao.vue?vue&type=style&index=0&id=bc715584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc715584",
  null
  
)

export default component.exports